import * as z from 'zod';
import { createSelectSchema } from 'drizzle-zod';
import type { QueryResult } from '@iichi/schema-database/types/item-picture';
import * as schema from '@iichi/schema-database';
import { mimeTypeToExtension, mimeTypeSchema, type MimeType } from '../lib/picture';

export const itemPictureSchema = createSelectSchema(schema.itemPicture)
  .pick({
    createdAt: true,
    height: true,
    itemId: true,
    order: true,
    text: true,
    updatedAt: true,
    width: true,
  })
  .extend({
    // 型の調整
    contentType: mimeTypeSchema,
    createdAt: z.coerce.date(),
    imagePath: z.string().regex(/^\/item\/\d+\/it-[a-zA-Z0-9]{13}-1200\.(jpg|gif|png)$/),
    updatedAt: z.coerce.date(),
  });

export type ItemPicture = z.infer<typeof itemPictureSchema>;

export const serialize = (data: QueryResult): ItemPicture => {
  const itemPicture = {
    ...data,
    imagePath: `/item/${data.itemId}/it-${data.slug.padStart(13, '0')}-1200.${mimeTypeToExtension(data.contentType as MimeType)}`,
  };

  return itemPictureSchema.parse(itemPicture);
};
